/* -----------------Third parties--------------- */
import { useState } from "react";
import { DatePickerModal, TimePickerModal } from "react-native-paper-dates";

interface DateTimePickerModalProps {
	isVisible: boolean;
	mode?: "date" | "time" | "datetime";
	onConfirm: (date: Date) => void;
	onCancel: () => void;
	date?: Date;
}

const DateTimePickerModal = ({
	isVisible,
	onConfirm,
	onCancel,
	date,
}: DateTimePickerModalProps) => {
	const [showDatePicker, setShowDatePicker] = useState(true);
	const [showTimePicker, setShowTimePicker] = useState(false);
	const [selectedDate, setSelectedDate] = useState<Date | undefined>(date);

	const handleDateConfirm = (params: unknown) => {
		const singleParams = params as { date?: Date };
		if (singleParams.date) {
			setSelectedDate(singleParams.date);
			setShowDatePicker(false);
			setShowTimePicker(true);
		}
	};

	const handleTimeConfirm = ({
		hours,
		minutes,
	}: { hours: number; minutes: number }) => {
		if (selectedDate) {
			const finalDateTime = new Date(selectedDate);
			finalDateTime.setHours(hours, minutes, 0, 0);
			onConfirm(finalDateTime);
		}
		setShowDatePicker(true);
		setShowTimePicker(false);
	};

	const handleCancel = () => {
		setShowDatePicker(true);
		setShowTimePicker(false);
		onCancel();
	};

	if (!isVisible) {
		return null;
	}

	return (
		<>
			<DatePickerModal
				visible={showDatePicker}
				onDismiss={handleCancel}
				onConfirm={handleDateConfirm}
				date={selectedDate}
				mode="single"
				locale="en"
				label="Select date"
				saveLabel="Set date"
			/>
			<TimePickerModal
				visible={showTimePicker}
				use24HourClock={false}
				onDismiss={handleCancel}
				cancelLabel="Cancel"
				confirmLabel="Set time"
				onConfirm={handleTimeConfirm}
				hours={selectedDate ? selectedDate.getHours() : 14}
				minutes={selectedDate ? selectedDate.getMinutes() : 30}
			/>
		</>
	);
};

export default DateTimePickerModal;
